import React from 'react';
import { Outlet } from 'react-router-dom';

import { FridayCheckinModal } from '@/components/friday-checkin/FridayCheckinModal';
import { PinnedDocsDock } from '@/components/pinned-documents';
import { GlobalSidebarProvider } from '@/contexts/GlobalSidebarContext';
import { HeaderVisibilityProvider } from '@/contexts/HeaderVisibilityContext';

import { Header } from './Header';

export const MainLayout: React.FC = () => {
  return (
    <HeaderVisibilityProvider>
      <GlobalSidebarProvider>
        <div className="flex h-screen w-full">
          <div className="flex flex-col flex-1 overflow-hidden">
            <Header />
            {/* Use a single app-level scroll container; hide its visual scrollbar track to avoid the mini clipped bar under the header. */}
            <main className="flex-1 bg-background overflow-auto no-scrollbar">
              <Outlet />
            </main>
          </div>
          {/* <GlobalRightSidebar /> */}
        </div>
        {/* Pinned documents dock - Gmail-style floating dock at bottom */}
        <PinnedDocsDock />
        <FridayCheckinModal />
      </GlobalSidebarProvider>
    </HeaderVisibilityProvider>
  );
};
